import { useEffect, useRef } from "react";
import { pubSub } from "../../ably";
import { CHANNELS, SESSION_DETAILS_HISTORY } from "../../channel/channels.js";
import { queryClient } from "../../api/queryClient.js";
import { buildSessionCacheKey, createCmeCommonChannelConfig, isPartialCmeEvent } from "../../realtime/channelRegistry.js";
import { applyChannelMessage } from "../../realtime/channelSyncEngine.js";

export default function useComponentConfigHistorySync(sessionId) {
  const doneRef = useRef(false);

  useEffect(() => {
    if (!sessionId) return;
    doneRef.current = false;
    let cancelled = false;
    const cacheKey = buildSessionCacheKey(sessionId);
    const config = createCmeCommonChannelConfig(sessionId);

    async function runOnce() {
      if (doneRef.current || cancelled) return;
      doneRef.current = true;
      const history = await pubSub.getChannelHistoryWithMeta(CHANNELS.SESSION_DETAILS, SESSION_DETAILS_HISTORY);
      if (cancelled) return;
      for (const item of history) {
        const msg = item?.data;
        if (!msg || typeof msg !== "object") continue;
        const setting = msg.setting || msg.data?.setting;
        const hasSetting = setting && typeof setting === "object";
        if (!hasSetting) continue;
        const isFull = msg.kind === "session" || msg.kind === "stream-status" || (msg.data?.detail && msg.data?.setting) || (msg.detail && msg.hosting && msg.streaming);
        if (isFull) continue;
        if (!isPartialCmeEvent(msg)) continue;
        applyChannelMessage({
          queryClient,
          cacheKey,
          config,
          message: { id: item.id, timestamp: item.timestamp, raw: msg },
        });
        break;
      }
    }

    if (pubSub.isConnected) runOnce();
    const handler = (connected) => {
      if (connected) runOnce();
    };
    pubSub.onConnectionChange(handler);
    return () => {
      cancelled = true;
      pubSub.offConnectionChange(handler);
    };
  }, [sessionId]);
}
